import SimpleLightbox from "simplelightbox";


export default function gallery() {
    const gallery = document.querySelectorAll('[data-gallery-item]');
    if (gallery && gallery.length > 0) new SimpleLightbox(gallery, { });
}